import { render, staticRenderFns } from "./material-uploading.vue?vue&type=template&id=7b9da194"
import script from "./material-uploading.vue?vue&type=script&lang=js"
export * from "./material-uploading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports